import TimePickerComponent from 'react-time-picker'
import { theme, fontSizes } from 'utils'
import styled from '@emotion/styled'
import { useField, useFormikContext } from 'formik'
import { IVenueFormValues } from 'FormPage/FormPage'
import get from 'lodash.get'
import { IInputProps } from '@nextretreat/ui-components/dist/Input'
import UITheme from '@nextretreat/ui-components/dist/Theme'

interface ITimePickerProps extends Omit<IInputProps, 'name' | 'as'> {
  name: string
}

export const StyledTimePicker = styled(TimePickerComponent as any)`
  min-height: 42px;
  display: flex;
  width: 100%;
  font-size: ${theme.fontSizes.m};
  color: ${UITheme.COLORS.TXT_DEFAULT};
  border: 1px solid ${UITheme.COLORS.BG_DIVIDER};
  background-color: ${UITheme.COLORS.WHITE};
  border-radius: ${theme.radius.m};
  word-break: break-all;
  appearance: none;
  flex: 1;

  &:disabled {
    background-color: ${UITheme.COLORS.BG_DISABLED};
    color: ${UITheme.COLORS.TXT_DISABLED};
    border-color: ${UITheme.COLORS.BG_DIVIDER};
    cursor: not-allowed;
  }

  &:placeholder {
    color: ${UITheme.COLORS.TXT_PLACEHOLDER};
  }

  &:hover {
    border-color: ${UITheme.COLORS.BG_DARK_DIVIDER};
  }

  &:focus-visible {
    outline: 2px solid #96c0ff;
    outline-offset: 2px;
  }

  ${({ isInvalid }: { isInvalid?: boolean }) =>
    isInvalid &&
    `
    background-color: ${UITheme.COLORS.ERROR_LIGHT};
    border-color: ${UITheme.COLORS.ERROR_DEFAULT} !important;
  `}
  & > div {
    padding-left: ${theme.space.m};
    border: none;
    display: flex;
    align-items: center;
    text-align: left;
  }

  & input {
    border: none;
  }

  & > div > div {
    padding-left: 0;
  }

  & span {
    min-height: 100%;
  }
`

const InputWrap = styled('div')`
  position: relative;
  flex-grow: 1;
`

export const Label = styled('p')`
  color: ${UITheme.COLORS.TXT_MAIN};
  text-align: left;
  font-weight: 500;
  font-size: ${fontSizes.m};
  margin: 0;
`

const TimePicker = ({ label, name, ...passingProps }: ITimePickerProps) => {
  const [field] = useField({ name })
  const { errors, touched, setFieldValue, values } =
    useFormikContext<IVenueFormValues>()

  return (
    <InputWrap>
      {label && <Label>{label}</Label>}

      <StyledTimePicker
        disableClock
        {...field}
        {...passingProps}
        isInvalid={!!(get(errors, name) && get(touched, name))}
        clearIcon={null}
        onChange={(val: string) => setFieldValue(name, val)}
        value={get(values, name) as string}
      />
    </InputWrap>
  )
}

export default TimePicker
